import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToggleNavbar } from "../../Redux/Actions/uiActions";
import { HiOutlineDesktopComputer, HiMenuAlt1 } from "react-icons/hi";
import { RiContactsLine } from "react-icons/ri";
import { FaLaptopCode } from "react-icons/fa";
import { SiHomeassistant } from "react-icons/si";
import { useTranslation } from "react-i18next";
export const FullItemsNavbar = () => {
	const { showSidebar } = useSelector((state) => state.ui);
	const [t] = useTranslation("global");

	const dispatch = useDispatch();

	const handleClose = () => {
		dispatch(setToggleNavbar(!showSidebar));
	};

	return (
		<>
			<div
				style={{
					color: "#f2f2f2",
				}}
				className="w-full h-screen animate__animated animate__fadeInLeft flex flex-col"
			>
				{showSidebar && (
					<div className="flex tabletbig:hidden text-gray-50">
						<HiMenuAlt1
							className="mx-3 text-2xl font-bold cursor-pointer text-gray-50"
							onClick={handleClose}
						/>
					</div>
				)}
				<div>
					<div className="tabletbig:d:flex my-4 mx-3">
						<a
							href="#home"
							className="cursor-pointer flex items-center font-md p-2 mt-2"
							onClick={handleClose}
						>
							<SiHomeassistant className="text-2xl mx-5 text-gray-50" />
							<p className="text-white font-Poppins font-semibold text-xl">
								{t("home")}
							</p>
						</a>
					</div>
				</div>

				<div className="tabletbig:flex my-4 ml-2">
					<a
						href="#exp"
						className="cursor-pointer flex items-center font-md p-2 mt-1"
						onClick={handleClose}
					>
						<HiOutlineDesktopComputer
							className="text-gray-50 text-2xl mx-5 "
							style={{
								color: "#fafafa",
							}}
						/>
						<p className="text-WhiteSocial font-Poppins font-semibold text-xl">
							{t("experience")}
						</p>
					</a>
				</div>

				<div className="tabletbig:flex my-5 ml-4">
					<a
						href="#skill"
						className="cursor-pointer flex items-center"
						onClick={handleClose}
					>
						<FaLaptopCode className="text-gray-50 text-2xl mx-5 " />
						<p className="text-WhiteSocial font-Poppins font-semibold text-xl">
							{t("skills")}
						</p>
					</a>
				</div>

				<div className="tabletbig:flex my-4 ml-3">
					<a
						href="#contact"
						className="cursor-pointer flex items-center"
						onClick={handleClose}
					>
						<RiContactsLine className="text-gray-50  text-2xl mx-5 " />
						<p className="text-WhiteSocial font-Poppins font-semibold text-xl">
							{t("contact-me")}
						</p>
					</a>
				</div>
			</div>
		</>
	);
};
